import { render } from "./memberManage.vue?vue&type=template&id=5c120f7e&scoped=true"
import script from "./memberManage.vue?vue&type=script&lang=js"
export * from "./memberManage.vue?vue&type=script&lang=js"

import "./memberManage.vue?vue&type=style&index=0&id=5c120f7e&scoped=true&lang=css"
import "./memberManage.vue?vue&type=style&index=1&id=5c120f7e&lang=css"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c120f7e"]])

export default __exports__